import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/app/(public)/[sport]/players/[id]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/game/card/detailed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/team/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameProvider"] */ "/codebuild/output/src1214854546/src/client/src/utils/providers/game.tsx");
